import React, { useState } from "react";
import {
  Stack,
} from "@mui/material";

import { CollapseShiftLabel } from "./CollapseButtons.jsx";
import {
  InputPercentage,
  InputPercentageInflation,
  InputPercentageSpouse,
} from "../Components/Inputs/Input_Percentage.jsx";
import { InputYear } from "../Components/Inputs/Input_Year.jsx";
import { InputMoney } from "../Components/Inputs/Input_Money.jsx";
import { InputAge } from "../Components/Inputs/Input_Age.jsx";
import { errorSetPlus } from "../Components/Inputs/Input_Fns.jsx";
import { InputRepeat } from "../Components/Inputs/Input_Number.jsx";
import { InputSelect1, InputSelectMonth } from "../Components/Inputs/Select.jsx";
import { Arrayify } from "../Functions/utils.jsx";

const ValueInflatable = ({
  avail,
  form,
  onChange,
  doUpTo = false,
  uptoage,
  doRepeat = false,
  repeat,
  dosp = false,
  dospAlways = false,
  SpousePercentage,
  tooltip = "The value of the account on Dec 31 of the stated year.",
  doInfR = false,
  doThr = true,
  name,
  valueMin = 0,
  valueMax = 10000000,
  negative = false,
  label,
  xlabel,
  showInf = true,
  doInf = true,
  doInfAlways = false,
  infMinPct = 0,
  doInfCap = false,
  doInfMult = false,
  doInfOffset = false,
  color,
  disabled = false,
  errors_ = null,
  onError = null,
  doStartMonth = null,
  startMonth = "",
  onChange_StartMonth,
  doFinishMonth = null,
  finishMonth = "",
  onChange_FinishMonth,
  birthYear = 0,
}) => {
  const [errors, setErrors] = useState({})
  const [addInf, setAddInf] = useState(showInf);
  const onChange_any = (n, v) => {
    console.log(form);
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf, uptoage, SpousePercentage, name, repeat);
  };



  const onChange_t = (e) => {
    // console.log(e.target.name);
    // console.log(e.target.value);
    onChange_any(e.target.name, e.target.value);
  };

  const onChange_uptoage = (e) => {
    onChange(form, e.target.value, SpousePercentage, name, repeat);
  };
  const onChange_repeat = (e) => {
    onChange(form, uptoage, SpousePercentage, name, e.target.value);
  };
  const onChange_SpousePercentage = (e) => {
    onChange(form, uptoage, e.target.value, name, repeat);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Stack direction="row" spacing={2} sx={{ my: 0 }}>
      <InputMoney
        label={label}
        xlabel={xlabel}
        money={form.Value}
        disabled={disabled}
        min={valueMin}
        max={valueMax}
        negative={negative}
        onChange={onChange_t}
        tooltip={tooltip}
        errors_={errors_}
        onError={(e) => myError(label, null, e)}
      />

      {dosp && (
        <InputPercentageSpouse
          percent={SpousePercentage}
          disabled={disabled || (form.Value === 0 && dospAlways === false)}
          onChange={onChange_SpousePercentage}
          onError={(e) => myError("percent_spouse", null, e)}
        />
      )}
      {doUpTo && (
        <InputAge
          age={uptoage}
          min={0}
          width={90}
          disabled={disabled || form.Value === 0}
          onChange={onChange_uptoage}
          tooltip="The value will be utilized up to and including the age as entered here, if 0, it will only be for this year"
          onError={(e) => myError("uptoage", null, e)}
          birthYear={birthYear}
        />
      )}
      {doStartMonth && (
        <InputSelectMonth
          label="Start Month"
          name="StartMonth"
          value={startMonth}
          onChange={onChange_StartMonth}
          errors={errors}
          tooltip="The first month in the first year that this is applicable."
          onError={(e) => myError("startMonth", null, e)}
        />
      )}
      {doFinishMonth && (
        <InputSelectMonth
          label="Final Month"
          name="FinishMonth"
          value={finishMonth}
          onChange={onChange_FinishMonth}
          errors={errors}
          tooltip="The last month in the last year that this is applicable."
          onError={(e) => myError("finishMonth", null, e)}
        />
      )}
      {doRepeat && (
        <InputRepeat
          number={repeat}
          disabled={disabled || form.Value === 0 || uptoage === 0}
          onChange={onChange_repeat}
          tooltip="The value will be utilized up to and including the UpToAge repeating every N years as entered here (default of empty,0 means every year, same as 1)"
          onError={(e) => myError("uptoage", null, e)}
        />
      )}
      <CollapseShiftLabel
        add={addInf}
        color={color}
        disabled={disabled && !addInf}
        onClick={(e) => setAddInf(!addInf)}
      />

      {addInf && (
        <>
          <Stack direction="row" spacing={2} sx={{ my: 2 }}>
            <InputSelect1
              label="Inflate"
              value={form.Type}
              disabled={disabled || !doInf || (form.Value === 0 && doInfAlways === false)}
              onChange={onChange_t}
              name="Type"
              minWidth={120}
              avail={Arrayify(avail.InflationTypes).filter(method => doThr || method !== "Threshold")}
              tooltip="Yearly, the value is increased yearly base on Inflation (for Liabilities, that is until the initial year only) Threshold: the value is increased yearly but only takes effect on the threshold boundary."
            />

            <InputYear
              label="Base Year"
              disabled={disabled || !doInf || form.Type === "Never" || (form.Value === 0 && doInfAlways === false)}
              year={form.Year}
              onChange={onChange_t}
              width={90}
              tooltip="The $ value is in terms of $ in this year, future years will be inflation adjusted. Usually this will be the year you 'entered the value'"
              onError={(e) => myError("inf year", null, e)}
            />

            {doThr && (
              <InputMoney
                xlabel="Threshold"
                money={form.Threshold}
                name="Threshold"
                disabled={
                  disabled || !doInf || (form.Value === 0 && doInfAlways === false) || form.Type !== "Threshold"
                }
                negative={negative}
                max={10000}
                sx={{ width: 80 }}
                onChange={onChange_t}
                tooltip="The value is only adjusted for inflation when it cross this threshold. The value is incremented every year but will only be changed when this threshold is met."
                onError={(e) => myError("thresh_money", null, e)}
              />
            )}
            {doInfR && (
              <InputPercentageInflation
                percent={form.Rate}
                disabled={disabled || !doInf || form.Type === "Never" || (form.Value === 0 && doInfAlways === false)}
                onChange={onChange_t}
                minPct={infMinPct}
                onError={(e) => myError("percent_infl", null, e)}
              />
            )}
            {doInfMult && (
              <InputPercentage
                label="Inf Mult %"
                name="RateMultiplier"
                percent={form.RateMultiplier}
                disabled={disabled || !doInf || form.Type === "Never" || (form.Value === 0 && doInfAlways === false)}
                onChange={onChange_t}
                maxPct={200}
                tooltip="Inflation Rate is multiplied by this percentage value. 0 is the same as 100 (rate is unchanged)."
                onError={(e) => myError("percent_inflmult", null, e)}
              />
            )}
            {doInfOffset && (
              <InputPercentage
                label="Inf +/- %"
                name="RateOffset"
                percent={form.RateOffset}
                disabled={disabled || !doInf || form.Type === "Never" || (form.Value === 0 && doInfAlways === false)}
                onChange={onChange_t}
                minPct={-20}
                maxPct={20}
                tooltip="Inflation Rate delta.  This is added to the scenario inflation after the multiplier modifier. If this is negative and the drops below 0, we cap at 0."
                onError={(e) => myError("percent_infloffset", null, e)}
              />
            )}
            {doInfCap && (
              <InputPercentageInflation
                label="Inf Cap %"
                name="RateCap"
                percent={form.RateCap}
                disabled={disabled || !doInf || form.Type === "Never" || (form.Value === 0 && doInfAlways === false)}
                onChange={onChange_t}
                maxPct={200}
                tooltip="Inflation Rate is capped to this value."
                onError={(e) => myError("percent_inflcap", null, e)}
              />
            )}


          </Stack>
        </>
      )}
    </Stack>
  );
};

export default ValueInflatable;
